import { createApp } from 'vue'
import App from './App.vue'
import './assets/styles.css'
import router from './router'
import store from './store';

import vue3GoogleLogin from 'vue3-google-login'

import Tooltip from 'primevue/tooltip';
import Button from 'primevue/button';
import ToastNotification from './components/Toast.vue';

import './plugins/axios'; // Axiosインターセプターの設定
import './plugins/storage';

// アプリケーションの初期化
const app = createApp(App);

// トースト通知を設定
const toast = {
  install(app) {
    // グローバルトーストコンポーネントを追加
    const ToastComponent = createApp(ToastNotification).mount(
      document.createElement('div')
    );
    document.body.appendChild(ToastComponent.$el);

    // グローバルメソッドを追加
    app.config.globalProperties.$toast = {
      show(message, options) {
        ToastComponent.show(message, options);
      },
      info(message, options = {}) {
        this.show(message, { ...options, type: 'info' });
      },
      success(message, options = {}) {
        this.show(message, { ...options, type: 'success' });
      },
      warning(message, options = {}) {
        this.show(message, { ...options, type: 'warning' });
      },
      error(message, options = {}) {
        this.show(message, { ...options, type: 'error' });
      }
    };
  }
};

app
  .use(router)
  .use(store)
  .use(vue3GoogleLogin, {
    clientId: process.env.VUE_APP_GOOGLE_CLIENT_ID,// クライアントID
    scope: 'email profile openid https://www.googleapis.com/auth/youtube.readonly'
  })
  .directive('tooltips', Tooltip)
  .directive('Button', Button)
  .use(toast)
  .mount('#app')


